module.exports = "/_next/static/images/Hero@2x-ea3b13bcc2c1a74bdd7a4f51ff2a7dfa.webp";